import { View } from '@react-pdf/renderer';
import PDFWrapper, { DukeFooterLogo, Message, Row, SignatureSection } from '../PdfLayout';
import ProgressReportProps from './types';

function ProgressReport({ data }: { data: ProgressReportProps }): React.ReactElement {
  const labels = {
    name: 'Name of Student:',
    USI: 'USI:',
    dob: 'Date of Birth:',
    course: 'Course:',
    startDate: 'Commencement Date:',
    studySchedule: 'Study Schedule:',
  };

  return (
    <PDFWrapper title="Progress Report">
      <View
        style={{
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
          padding: '16px',
        }}
      >
        <View>
          {Object.keys(labels).map((key) => {
            if (labels[key] && data[key]) {
              return <Row key={key} label={labels[key]} value={data[key]} />;
            }
            return null;
          })}
          <Message
            text={
              data.completionDate
                ? `This student was enrolled ${data.studySchedule.toLowerCase()} for ${data.progressWeeks} weeks and fulfilled all course requirements, with a completion date of ${data.completionDate}.`
                : `The student has been participating in ${data.studySchedule.toLowerCase()} study for ${data.progressWeeks} weeks and is still continuing their coursework. The student has made satisfactory progress in their course.`
            }
          />
          <View style={{ marginTop: 32 }}>
            <SignatureSection signatureDate={data.signatureDate} />
          </View>
        </View>
        <View>
          <DukeFooterLogo />
        </View>
      </View>
    </PDFWrapper>
  );
}

export default ProgressReport;
